// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__VJtHQ","cardContainer":"Partners_cardContainer__1lE8_","card":"Partners_card__HJoan","logo":"Partners_logo__Fo1ko"};